import React, { useEffect, useState } from "react";
import {
  IoIosArrowRoundBack,
  IoIosArrowRoundForward,
  IoIosPersonAdd,
} from "react-icons/io";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/Auth";
import { RotatingLines } from "react-loader-spinner";


const CreditSalesRepaymentToday = () => {
  const { requestWithAuth } = useAuth();
  const [sales, setSales] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);

  const fetchCreditSales = async (page_size, search_query, current_page) => {
    setLoading(true);
    try {
      const data = await requestWithAuth(
        `/report/sales/credit/today?page=${current_page}&pageSize=${page_size}&search=${search_query}`,
        "GET"
      );
      setSales(data?.results);
      setNextPage(data?.next);
      setPrevPage(data?.prev);
      setTotalPages(Math.ceil(data?.count / pageSize));
    } catch (error) {
      console.error("Error fetching users data:", error);
    } finally {
      setLoading(false);
    }
  };

  const filterSalesList = (search_query) => {
    setSearch(search_query);
    setCurrentPage(1); 
  };

  const handleNextPage = () => {
    if (nextPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (prevPage) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];
    const totalNumbersToShow = 3; // Number of pages to show around the current page
    const totalPagesToShow = 5; // Total pages to show at start and end

    let startPage = Math.max(1, currentPage - totalNumbersToShow);
    let endPage = Math.min(totalPages, currentPage + totalNumbersToShow);

    // Always show the first page
    if (startPage > 1) {
      pageNumbers.push(1);
      if (startPage > 2) {
        pageNumbers.push("...");
      }
    }

    // Show the numbers around the current page
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    // Always show the last page
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push("...");
      }
      pageNumbers.push(totalPages);
    }

    return pageNumbers.map((number) => (
      <button
        key={number}
        onClick={() => number !== "..." && handlePageClick(number)}
        className={
          number === currentPage
            ? "border border-[#979797] bg-gradient-to-b from-white to-[#dcdcdc] py-[0.5rem] px-[1rem]"
            : "py-[0.5rem] px-[1rem]"
        }
      >
        {number}
      </button>
    ));
  };

  useEffect(() => {
    fetchCreditSales(pageSize, search, currentPage);
  }, [search, currentPage, pageSize]);

  return (
    <div className="p-[20px]">
        
      <div className="py-[32px] flex items-center justify-between ">
        <div className="flex items-center gap-3">
          <IoIosPersonAdd className="text-[19px]" />
          <h4 className="text-[19px]">
            <b>Credit Repayment Sales</b> - Report
          </h4>
        </div>
        
      </div>
      <div className="border border-[#ddd] bg-white">
        <div className="p-[20px]">
          <h5 className="my-[2px] text-[17px]">Today's Repayment Sales Report</h5>
        </div>
        <div className="p-[20px]">
          <div className="p-[20px] border border-[#ddd]">
            <div className="pt-[20px] flex justify-between mb-[20px]">
              <div className=" flex items-center gap-5">
                <div className="flex">
                  <div className="bg-[#fcfcfc] border border-[#ddd] py-[7px] px-[12px] cursor-pointer">
                    CSV
                  </div>
                  <div className="bg-[#fcfcfc] border border-[#ddd] py-[7px] px-[12px] cursor-pointer">
                    PDF
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <b>Show:</b>
                  <select
                    name=""
                    id=""
                    onChange={(e) => setPageSize(e.target.value)}
                    className="border border-[#ddd] rounded-[3px] py-[7px] px-[12px] text-[13px]"
                  >
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <b>Filter:</b>
                <input
                  type="text"
                  placeholder="Type to filter..."
                  className="outline-none border border-[#ddd] rounded-[3px] h-[36px] w-full text-[#333] text-[13px] px-[12px] py-[7px]"
                  onChange={(e) => filterSalesList(e.target.value)}
                />
              </div>
            </div>

            <div className="overflow-auto ">
              {!loading ? (
                <table className="border-collapse w-full">
                  <thead>
                    <tr className="text-left">
                      <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                        Customer
                      </th>
                      <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                        Processed By
                      </th>
                      <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                        Total Price
                      </th>
                      <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                        Item Name
                      </th>
                      <th className="border-b border-t border-[#bbb] py-[12px] px-[20px]">
                        Processed Date
                      </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    {sales?.map((sale, index) => (
                      <tr key={index} className="text-left">
                        <td className="border-b border-[#bbb] py-[12px] px-[20px]">
                          {sale?.customer}
                        </td>
                        <td className="border-b border-[#bbb] py-[12px] px-[20px]">
                          {sale?.processed_by}
                        </td>
                        <td className="border-b border-[#bbb] py-[12px] px-[20px]">
                          {sale?.amount_paid}
                        </td>
                        <td className="border-b border-[#bbb] py-[12px] px-[20px]">
                          {sale?.item_name}
                        </td>
                        <td className="border-b border-[#bbb] py-[12px] px-[20px]">
                          {sale?.processed_date}
                        </td>

                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="flex items-center justify-center">
                  <RotatingLines
                    visible={true}
                    height="36"
                    width="36"
                    color="black"
                    strokeWidth="5"
                    animationDuration="0.75"
                    ariaLabel="rotating-lines-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                  />
                </div>
              )}
              {sales?.length <= 0 && !loading && (
                <p className="text-center py-5">No data availabe in table</p>
              )}
              <div className="flex justify-between pt-[20px]">
                <p className="text-[12px] text-[#888]">
                  Showing {currentPage} of {totalPages} pages
                </p>
                <div className="flex items-center gap-2">
                  <IoIosArrowRoundBack className="text-[25px]" onClick={()=>handlePreviousPage()} />
                  {renderPageNumbers()}
                  <IoIosArrowRoundForward className="text-[25px]" onClick={()=>handleNextPage()} />
                </div>
              </div>
            </div>
          </div>
        </div>
        .
      </div>
    </div>
  );
};

export default CreditSalesRepaymentToday;
